// extracted by mini-css-extract-plugin
export default {"right-panel":"right-panel_right-panel__E13Xe","current-lot-status":"right-panel_current-lot-status__wQA9j"};